export default __webpack_public_path__ + "static/media/avatar.f6b9b89b.png";